import {
  Assistant,
  LocalLibraryRounded,
  QueryStatsRounded,
} from '@mui/icons-material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import BarChartIcon from '@mui/icons-material/BarChart';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import EditNoteIcon from '@mui/icons-material/EditNote';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import {
  deepPurple,
  green,
  lightBlue,
  lightGreen,
  orange,
  purple,
  red,
  teal,
} from '@mui/material/colors';

export const WISDOM_CHAT_LIST_DRAWER_WIDTH = 280;

export const SHOULD_OPEN_WISDOM_NAVBAR = 'shouldOpenWisdomNavbar';

export const WISDOM_CAPABILITIES: {
  prompt: string;
  label: string;
  icon: React.ReactElement<unknown>;
}[] = [
  {
    prompt: 'Summarize feedback about',
    label: 'Summarize feedback',
    icon: (
      <AutoAwesomeIcon fontSize="small" style={{ color: deepPurple['A100'] }} />
    ),
  },
  {
    prompt: 'Identify top issues related to',
    label: 'Identify top issues',
    icon: <ReportProblemIcon fontSize="small" style={{ color: red['200'] }} />,
  },
  {
    prompt: 'Find user quotes where',
    label: 'Find user quotes',
    icon: <FormatQuoteIcon fontSize="small" style={{ color: green['400'] }} />,
  },
  {
    prompt: 'List top feature requests related to',
    label: 'List feature requests',
    icon: <Assistant fontSize="small" style={{ color: lightBlue['400'] }} />,
  },
  {
    prompt: 'Draft a PRD on',
    label: 'Draft a PRD',
    icon: <EditNoteIcon fontSize="small" style={{ color: purple['A200'] }} />,
  },
  {
    prompt: 'Plot a trend chart for',
    label: 'Plot a trend',
    icon: (
      <TrendingUpIcon fontSize="small" style={{ color: lightGreen['400'] }} />
    ),
  },
  {
    prompt: 'Create a bar chart for',
    label: 'Create a bar chart',
    icon: <BarChartIcon fontSize="small" style={{ color: teal['400'] }} />,
  },
  {
    prompt: 'Do a root cause analysis for',
    label: 'Do an RCA',
    icon: (
      <QueryStatsRounded fontSize="small" style={{ color: orange['400'] }} />
    ),
  },
  {
    prompt: 'Draft an Issue ticket about',
    label: 'Draft an Issue ticket',
    icon: (
      <ConfirmationNumberIcon
        fontSize="small"
        style={{ color: deepPurple['400'] }}
      />
    ),
  },
  {
    prompt: 'Write user stories for',
    label: 'Write user stories',
    icon: (
      <LocalLibraryRounded fontSize="small" style={{ color: red['300'] }} />
    ),
  },
];
